import { asyncActionState } from '@emm/core/util/async-action-state';
import { createSelector } from '@ngrx/store';
import * as RA from 'ramda-adjunct';
import { getManagementState, ManagementState } from '../management.reducer';
import { BaseState } from './management-base.reducer';
import {SearchFilter} from '@emm/core/models/search-filter';
import {Screen} from '@emm/core/models/screen.model';


const getState = createSelector(getManagementState, (state: ManagementState) => state?.base);

const asyncActionStateSelectors = asyncActionState.getSelectors(getState);

const getInitialized = createSelector(getState, (state: BaseState) => state.initialized);
const getScreens = createSelector(getState, (state: BaseState) => state.screens);
const getSelectedScreen = createSelector(getScreens, (screens: Screen[]) => screens.find((screen) => RA.isTrue(screen.selected)));
const getSelectedCountry = createSelector(getState, (state: BaseState) => state.selectedCountry);
const getItemDetail = createSelector(getState, (state: BaseState) => state.itemDetail);
const getItemLocaleDetail = createSelector(getState, (state: BaseState) => state.itemLocaleDetail);
const getItemTypeDetail = createSelector(getState, (state: BaseState) => state.itemTypeDetail);
const getLocationSetTypeDetail = createSelector(getState, (state: BaseState) => state.locationSetTypeDetail);
const getAttributeDetail = createSelector(getState, (state: BaseState) => state.attributeDetail);
const getEmergencyItemDetail = createSelector(getState, (state: BaseState) => state.emergencyItemDetail);
const getItemGroupingDetail = createSelector(getState, (state: BaseState) => state.itemGroupingDetail);
const getLocationSetDetail = createSelector(getState, (state: BaseState) => state.locationSetDetail);
const getRevoteDetails = createSelector(getState, (state: BaseState) => state.revoteDetails);
const getLanguageAssignmentDetails = createSelector(getState, (state: BaseState) => state.languageAssignmentDetails);
const getSearchFilter = createSelector(getState, (state: BaseState) => state.searchFilter);
const getSelected = createSelector(getState, (state: BaseState) => state.selected);
const getSavedSelections = createSelector(getState, (state: BaseState) => state.selections);
const getLocations = createSelector(getState, (state: BaseState) => state.locations);
const getFilteredItems = createSelector(
    getLocations,
    getSearchFilter,
    (locations: any[], filter: SearchFilter) => {

        const filterString = Array.isArray(filter?.value)
            ? (filter?.value as string[]).join(',').toLowerCase()
            : filter?.value
                ? (filter?.value.toLowerCase() as string)
                : '';

        const newObject = locations.map((location) => {
            return {
                ...location,
                name: location.name + ` (${location.tag})`
            };
        });
        return newObject.filter(option => option.name.toLowerCase().includes(filterString));
    }
);

export const ManagementBaseSelectors = {
    ...asyncActionStateSelectors,
    getInitialized,
    getScreens,
    getSelectedScreen,
    getSelectedCountry,
    getItemDetail,
    getItemLocaleDetail,
    getItemTypeDetail,
    getLocationSetTypeDetail,
    getAttributeDetail,
    getEmergencyItemDetail,
    getItemGroupingDetail,
    getLocationSetDetail,
    getRevoteDetails,
    getSelected,
    getSavedSelections,
    getSearchFilter,
    getFilteredItems,
    getLocations,
};
